import { useEffect, useState } from 'react';
import { isFeatureFlagEnabled } from '../utils/featureFlags';
// null while the flags load, then whether the flag is on (off on any failure).
export var useFeatureFlag = function (flagName) {
    var _a = useState(null), isEnabled = _a[0], setIsEnabled = _a[1];
    useEffect(function () {
        var isMounted = true;
        isFeatureFlagEnabled(flagName).then(function (enabled) {
            if (isMounted) {
                setIsEnabled(enabled);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [flagName]);
    return isEnabled;
};
